import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTilesViewIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 22 16",
	style: { enableBackground: "new 0 0 22 16" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	    .grid-icon-st0{fill:currentColor;}\n    "
	}), /* @__PURE__ */ _jsx("path", {
		className: "grid-icon-st0",
		d: "M0.833984 7.29175H6.87565V0.041748H0.833984V7.29175ZM0.833984 15.7501H6.87565V8.50008H0.833984V15.7501ZM8.08398 15.7501H14.1257V8.50008H8.08398V15.7501ZM15.334 15.7501H21.3757V8.50008H15.334V15.7501ZM8.08398 7.29175H14.1257V0.041748H8.08398V7.29175ZM15.334 0.041748V7.29175H21.3757V0.041748H15.334Z"
	})]
});
export default SvgTilesViewIcon;
